// extracted by mini-css-extract-plugin
export var boxItems = "_a2-1";
export var boxItemsLg = "_a2-2";
export var button = "_a2-7";
export var buttonLg = "_a2-8";
export var filterGroupBox = "_a2-0";
export var icon = "_a2-3";
export var iconSecondary = "_a2-6";
export var iconWrapper = "_a2-4";
export var iconWrapperLg = "_a2-5";